"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Link = function Link(_ref) {
  var active = _ref.active,
      children = _ref.children,
      _onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      !active && _onClick();
    }
  }, children));
};

Link.propTypes = (0, _defineProperty2["default"])({
  "onClick": _propTypes["default"].func.isRequired,
  active: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].node.isRequired
}, "onClick", _propTypes["default"].func.isRequired);
var _default = Link;
exports["default"] = _default;
//# sourceMappingURL=Link.js.map